module.exports = __webpack_public_path__ + "img/in.8a512f06.svg";